module.exports = __webpack_public_path__ + "img/l-play.49603ace.png";